
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { getPlacingsByDiscipline } from "data/Querys";
import { ColumnRank, ColumnNoc, ColumnOrganisation } from "components/common/TableColumns"
import MirsTable from 'components/general/table/Table.js';
import Label from 'components/general/Label';
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import PageHeader from 'components/common/PageHeader';
import { useEventUnit } from "components/common/EventUnit"
import useViewport from 'components/general/useViewPort';



export default function Placings() {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_rsc } = useUrlFriendlyToParameters()
    const eu = useEventUnit()


    //Get Data
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['placingTableByDiscipline', mirs_competition, mirs_discipline, mirs_language],
            queryFn: getPlacingsByDiscipline,
            refetchInterval: 60000,
            //    staleTime: 50000,
            //staleTime: Infinity,
            //refetchIntervalInBackground: true,
        });

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }
    if (!data?.placingsBySport) { return <NotAvailable /> }
    let swTab = data?.placingsBySport.length > 1 ? true : false

    return (
        <>
            <PageHeader title={<Label data="Placings" />} />
            {swTab ?
                <Tabs
                    id="mirs-placing"
                    className="mb-3 mirs-tab-result"
                //defaultActiveKey={`1-${mirs_rsc}`}
                >
                    {  //Iterate for every placing 
                        data?.placingsBySport?.map((item) =>
                            <Tab key={`placing-tab-${item?.documentCode}`} eventKey={`${item?.documentCode}`} title={eu(item?.documentCode, true)} >
                                <Label data="placing-text" values={{ num: item?.finishedEvents, numTotal: item?.totalEvents }} ></Label>
                                <PlacingItem data={item} />
                            </Tab>
                        )
                    }
                </Tabs>
                :
                <>
                    <h3>{eu(data?.placingsBySport[0]?.documentCode, true)}</h3>
                    <Label data="placing-text" values={{ num: data?.placingsBySport[0]?.finishedEvents, numTotal: data?.placingsBySport[0]?.totalEvents }} ></Label>
                    <PlacingItem data={data?.placingsBySport[0]} />
                </>
            }

        </>
    )
};




function PlacingItem({ data }) {
    const { breakPoint } = useViewport();
    //    const [stateData, setStateData] = useState(data?.placingTable);

    //Check if node conected to table exists
    // const dataCheck = Array.isArray(data?.placingTable) ? data?.placingTable : []

    const dataCheck = data?.placingTable && JSON.parse(JSON.stringify(data?.placingTable)); //Deep copy all elements primitive values (ineficiente??)
    //Si no hacemos lo anterior se repintara cada vez que se carguen los datos aunque estos no hayan cambiado  ya que los datos se pasan por refencia y los detactara como que hay cambios con lo anterior
    //Copy organisation data in every row data for  table
    let placingNumbers = []
    let max = 0;
    dataCheck?.forEach((item, index) => {
        item.participant = { organisation: { ...item.organisation } }
        if (max < item?.placingNumbers?.length) {
            max = item?.placingNumbers?.length
            placingNumbers = item?.placingNumbers
        }



    });
    let wide = "8,".repeat(max / 4)
    wide = wide.slice(0, -1);

    let mobile = "4,".repeat(max / 2)
    mobile = mobile.slice(0, -1);



    //Define Columns 
    const tableColumns = useMemo(() => getColumns(placingNumbers), [])

    return (
        <MirsTable
            id={`mirs-table-placings`}
            data={dataCheck}
            columns={tableColumns}
            //showLoading={false}        
            colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? mobile : wide}
            showNavExtendedData={true}
            initialSortBy={[{ id: 'Rank', desc: false }]}
        />
    );


}


function createColumns(placingNumbers) {
    //  const cols = [1, 2, 3, 4, 5, 6, 7, 8]
    //  const labels = ['Header1st', 'Header2nd', 'Header3rd', '4th', '5th', '6th', '7th', '8th']
    let columns = []
    placingNumbers.forEach((col, index) => {
        columns.push(
            {
                Header: col?.code,
                enableRowSpan: false,
                //relatedId: 'Rank'+index,
                headerClassName: "text-center",
                id: 'HeaderRank' + index,
                columns: [

                    {
                        id: 'columnRank_' + index,
                        Header: <Label data={'HeaderPlaceShort'} />,
                        headerClassName: "text-end w-10",
                        isVisible: false,
                        columnIndex: ((index + 1) * 2) - 1,
                        accessor: (props) => (
                            props.placingNumbers
                                ? props?.placingNumbers.find(row => row.code === col?.code && row.type === 'TOT')?.rank
                                : ''
                        ),
                        disableSortBy: true,
                        className: "text-end"
                    },
                    {
                        id: 'columnPts_' + index,
                        Header: <Label data={'HeaderSortPoints'} />,
                        headerClassName: "text-end w-10",
                        isVisible: false,
                        columnIndex: (index + 1) * 2,
                        accessor: (props) => (
                            props.placingNumbers
                                ? props?.placingNumbers.find(row => row.code === col?.code && row.type === 'TOT')?.points
                                : ''
                        ),
                        disableSortBy: true,
                        className: "text-end"
                    },
                ]
            }
        )
    });
    return columns
}


function getColumns(placingNumbers) {
    return (
        [

            {
                Header: '-',
                enableRowSpan: true,
                relatedId: 'Rank',
                headerClassName: "text-end  align-middle",
                id: 'HeaderRank',
                columns: [ColumnRank({ disableSort: true, hasRankEqual: true, remove: true })]
            },
            {
                Header: '-',
                enableRowSpan: true,
                relatedId: 'NOC',
                headerClassName: "text-center d-none d-md-table-cell align-middle",
                id: 'HeaderNoc',
                columns: [ColumnNoc({ disableSort: true, remove: true })]
            },
            {
                Header: '-',
                enableRowSpan: true,
                relatedId: 'Organisation',
                headerClassName: "text-center align-middle",
                id: 'HeaderOrganisation',
                columns: [ColumnOrganisation({ onlyShortName: true, remove: true })]
            },

            ...createColumns(placingNumbers),
            ColumnPoints()
        ]


    )
}

export function ColumnPoints() {
    return (
        {
            Header: '-',
            enableRowSpan: true,
            relatedId: 'Points',
            headerClassName: "text-end align-middle w-5",
            id: 'HeaderPoints',
            columns: [
                {
                    Header: <Label data={'HeaderTotalPoints'} />,
                    accessor: 'points',
                    id: 'Points',
                    className: 'text-end',
                    headerClassName: 'text-end',
                    remove: true
                }
            ]
        }
    )
}